import type { IdentityOrchestratorErrorItem } from "@/services/UserIdentitiesService";
import type { ValidationError } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";
import { resolveErrorMessage, isWarningCode } from "@/screen/Identities/IdentityForm/identityErrorMessages";

/**
 * Convierte errors[] del orquestador en ValidationError[] para `IdentityErrorHelper`.
 * `field` usa el `code` estable; `message` aplica la tabla de mensajes amigables.
 * Los warnings (EXISTS_ACTIVE_IN_USER) se incluyen con su mensaje resuelto.
 */
export function mapOrchestratorErrorsToValidationErrors(errors: IdentityOrchestratorErrorItem[] | null | undefined): ValidationError[]
{
    if(!errors?.length)
    {
        return [];
    }
    return errors.map((e) =>
    ({
        field: e.code?.trim() || "General",
        message: resolveErrorMessage(e.code?.trim() || "", e.message),
    }));
}

/**
 * Extrae los errores de tipo warning (no bloqueantes) de un array de errores del orquestador.
 * Un éxito con `success: true` puede incluir warnings en `errors[]`.
 */
export function extractWarnings(errors: IdentityOrchestratorErrorItem[] | null | undefined): IdentityOrchestratorErrorItem[]
{
    if(!errors?.length)
    {
        return [];
    }
    return errors.filter((e) => isWarningCode(e.code?.trim() || ""));
}

/**
 * Combina todos los mensajes de error en una sola cadena para mostrar en un toast o banner.
 * Aplica la tabla de mensajes amigables sobre cada código.
 */
export function orchestratorErrorsToSingleMessage(errors: IdentityOrchestratorErrorItem[] | null | undefined): string
{
    if(!errors?.length)
    {
        return "";
    }
    return errors.map((e) => resolveErrorMessage(e.code?.trim() || "", e.message)).filter(Boolean).join(" ");
}